import { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation } from "react-router-dom";
import { Container, Grid, Typography, Box, Button } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import ExclamationIcon from "../../assets/exclamation.png";
import CssBaseline from "@mui/material/CssBaseline";
import { useTranslation } from "react-i18next";
import DynamicDeskLogo from "../../assets/DD_2_Weiss.png";

let stripePromise;

const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  }

  return stripePromise;
};

const PaymentIssue = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [stripeError, setStripeError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  /**
   * Listen for language changes from Electron menu
   */
  useEffect(() => {
    if (window.electronAPI?.language) {
      console.log("[PaymentIssue] Setting up Electron language listener");
      const cleanup = window.electronAPI.language.onChange((newLanguage) => {
        console.log(
          "[PaymentIssue] Language change received from Electron:",
          newLanguage
        );
        i18n.changeLanguage(newLanguage);
      });

      return cleanup; // Cleanup on unmount
    }
  }, [i18n]);

  // Use conditional operator to assign token from either props (from home) or location (from sign in)
  const email = location.state?.email;
  const item = {
    price: "price_1PpvlgHhKdOuxmUsLsJ16NP5",
    quantity: 1,
  };

  const checkoutOptions = {
    lineItems: [item],
    mode: "subscription",
    successUrl: `${window.location.origin}/onboarding-exercises`,
    cancelUrl: `${window.location.origin}/payment-issue`,
    customerEmail: email,
  };

  const redirectToCheckout = async () => {
    setLoading(true);
    console.log("redirectToCheckout");

    const stripe = await getStripe();
    const { error } = await stripe.redirectToCheckout(checkoutOptions);
    console.log("Stripe checkout error", error);

    if (error) setStripeError(error.message);
    setLoading(false);
  };

  if (stripeError) alert(stripeError);

  return (
    <Container component="main" maxWidth="lg" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Typography
        variant="h5"
        sx={{
          position: "absolute",
          top: 16,
          left: 24,
          color: "#fff",
        }}
      >
        <img
          src={DynamicDeskLogo}
          style={{ width: "12%", height: "12%", paddingTop: "12px" }}
          alt="DynamicDeskLogo"
        />
      </Typography>
      <Grid container sx={{ height: "100%" }}>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            p: 8,
          }}
        >
          <Typography variant="h3" gutterBottom sx={{ color: "#fff" }}>
            <b>{t("Hmmm... Something is wrong")}</b>
          </Typography>
          <Typography variant="h6" sx={{ color: "#fff", marginTop: "36px" }}>
            <b>{t("Looks like there is an issue with your subscription")}</b>
          </Typography>
          {/* Add more text if necessary */}
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <div
            style={{ width: "100vh", padding: "36px" }}
            className="white-background"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start", // Changed to 'flex-start' to align items to the left
                width: "100%",
              }}
            >
              <img
                src={ExclamationIcon}
                style={{
                  width: "86px",
                  height: "86px",
                  alignSelf: "flex-end",
                  marginBottom: "36px",
                }}
                alt="TrainingsPlanIcon"
              />
              <Typography
                component="h1"
                variant="h5"
                style={{ color: "#063bd0" }}
              >
                <b>{t("Oops!")}</b>
              </Typography>
              <Typography
                component="h1"
                variant="h6"
                style={{ color: "#063bd0", marginTop: "8px" }}
              >
                <b>
                  {t(
                    "Your payment either failed or was cancelled. Lets try again."
                  )}
                </b>
              </Typography>
              <p style={{ marginTop: "36px", color: "#4a4a4a" }}>
                Embark on a journey to wellness with a 7-day free trial!
              </p>

              <p style={{ color: "#4a4a4a" }}>
                Experience personalized physiotherapy routines, get proactive
                with exercise and movement reminders, and let expert therapists
                design a bespoke plan that syncs seamlessly with your calendar.
              </p>

              <p style={{ color: "#4a4a4a" }}>
                Take control and tailor your schedule for a balanced, healthier
                you. Dive into a world where your well-being comes first,
                risk-free!
              </p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end", // Aligns button and price on the left
                  width: "100%",
                  marginTop: "24px",
                }}
              >
                <h1 style={{ color: "#063bd0", fontSize: "32px", margin: 0 }}>
                  €20.00
                </h1>
                <Button
                  style={{
                    padding: "12px 24px",
                    marginLeft: "24px", // Adds spacing between button and price
                    cursor: "pointer",
                    fontSize: "16px",
                    borderRadius: "4px", // Rounded corners for the button
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Optional shadow for the button
                  }}
                  onClick={redirectToCheckout}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Buy"}
                </Button>
              </div>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PaymentIssue;
